/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_StorageInputs */



/**
* | output |
* | --- |
* | "Storage" |
*
* @param {Explorer_Info_Property_StorageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_storage = /** @type {((inputs?: Explorer_Info_Property_StorageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_StorageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Stockage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lagerung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Magazzinaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Хранилище")
	if (locale === "es") return /** @type {LocalizedString} */ ("Almacenamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("贮存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ストレージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भंडारण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Armazenar")
	return /** @type {LocalizedString} */ ("Storage")
});